import { useMemo } from "react";

import useColumns from "./useColumns";
import useUserUnit from "./useUserUnit";

export function useFieldTitleWithUnit(title?: string, property?: string): string {
  const columns = useColumns();
  const unitType = useUserUnit();

  return useMemo(() => {
    if (!title || !property || unitType === undefined) {
      return title || "";
    }

    const column = columns.find((col) => col.property === property);
    if (!column?.units) return title;

    const correctUnit = column.units[unitType];
    if (!correctUnit) return title;

    if (title.includes("(") && title.includes(")")) {
      return title.replace(/\([^)]*\)/, `(${correctUnit})`);
    }

    return title;
  }, [title, property, unitType, columns]);
}
